import React from 'react';

/**
 * Estado vacío reutilizable — equivalente a los frames `… / Vacío` de Figma.
 *
 * Distingue los dos casos que hasta ahora compartían una sola línea de texto:
 *  - `variant="empty"`   no hay nada todavía → onboarding, con acciones
 *  - `variant="noResults"` la búsqueda no encuentra nada → conserva lo tecleado
 *
 * Los `actions` son [{ label, onClick, tone }]; `tone` = 'primary' | 'secondary'.
 */
export default function EmptyState({
  icon = null,
  title,
  description = null,
  hint = null,
  actions = [],
  variant = 'empty',
  className = '',
}) {
  const dashed = variant === 'empty';

  return (
    <div
      className={`flex flex-col items-center justify-center gap-3 rounded-xl bg-[var(--card)] px-6 py-14 text-center ${
        dashed ? 'border border-dashed border-[var(--border)]' : 'border border-[var(--border)]'
      } ${className}`}
      role="status"
    >
      {icon && <div className="text-[var(--muted-foreground)]" aria-hidden>{icon}</div>}

      <h3 className="text-base font-semibold text-[var(--foreground)]">{title}</h3>

      {description && (
        <p className="max-w-md text-sm text-[var(--muted-foreground)]">{description}</p>
      )}

      {hint && (
        <p className="max-w-md text-xs text-[var(--muted-foreground)]">{hint}</p>
      )}

      {actions.length > 0 && (
        <div className="mt-2 flex flex-wrap items-center justify-center gap-2">
          {actions.map(({ label, onClick, tone = 'secondary' }) => (
            <button
              key={label}
              type="button"
              onClick={onClick}
              className={
                tone === 'primary'
                  ? 'rounded-sm bg-[var(--primary)] px-4 py-2 text-sm font-medium text-[var(--primary-foreground)] transition-colors hover:bg-[var(--primary-strong)]'
                  : 'rounded-sm border border-[var(--border)] bg-[var(--background)] px-4 py-2 text-sm font-medium text-[var(--foreground)] transition-colors hover:border-[var(--border-hover)]'
              }
            >
              {label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
